import { render, staticRenderFns } from "./UploadCard.vue?vue&type=template&id=2f2da064&"
import script from "./UploadCard.vue?vue&type=script&lang=js&"
export * from "./UploadCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports